import { render, staticRenderFns } from "./commonDrawer.vue?vue&type=template&id=6cb07436&scoped=true&"
import script from "./commonDrawer.vue?vue&type=script&lang=js&"
export * from "./commonDrawer.vue?vue&type=script&lang=js&"
import style0 from "./commonDrawer.vue?vue&type=style&index=0&id=6cb07436&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb07436",
  null
  
)

export default component.exports